import { ErrorsTranslate } from './errorsTranslate.model';

const errorsTranslatePTBR: ErrorsTranslate = {
  internalServerError: 'Erro no servidor. Tente novamente mais tarde',
  badRequest: 'Requisição inválida. Verifique os dados',
  notImplemented: 'Funcionalidade não disponível',
  resourceNotFound: 'Recurso não encontrado',
  unauthorizedAccess: 'Acesso não autorizado. Faça o login',
  forbiddenAccess: 'Ação não permitida',
  domainValidation: 'Dados inválidos. Verifique e tente novamente',
  invalidBodyRequest: 'Requisição mal formatada',
  invalidCredentials: 'E-mail ou senha inválidos',
  userNotFound: 'Usuário não encontrado',
  userAlreadyExists: 'E-mail já cadastrado',
  tenantNotFound: 'Organização não encontrada',
  tenantAlreadyExists: 'Organização já cadastrada',
  tenantIsInactive: 'Organização inativa',
  awsCognitoCodeMismatch: 'Código de verificação incorreto',
  awsCognitoExpiredCode: 'Código de verificação expirado',
  awsCognitoInvalidParameter: 'Parâmetro da requisição inválido',
  awsCognitoInvalidPassword: 'Senha inválida',
  awsCognitoUserNotConfirmed: 'Usuário não confirmado. Verifique seu e-mail',
  awsCognitoLimitExceeded: 'Limite de tentativas excedido. Tente mais tarde',
  leadNotFound: 'Cliente não encontrado',
  leadAlreadyExists: 'Cliente já cadastrado',
  membershipNotFound: 'Assinatura não encontrada',
  userInactive: 'Usuário inativo',
  userNotCreated: 'Não foi possível criar o usuário. Tente novamente',
  cannotResetAdminPassword:
    'Não é possível resetar a senha de outro administrador',
  subscriptionNotFound: 'Assinatura não encontrada para esta organização',
  planNotFound: 'Plano não encontrado',
  quotaExceeded: 'Limite do plano atingido. Faça upgrade pra criar mais.',
  subscriptionNoCancelScheduled:
    'Não há cancelamento agendado pra reverter nesta assinatura.',
  subscriptionNoBillingCycle:
    'Esta assinatura não tem ciclo de cobrança ativo pra aplicar a operação.',
  tenantDocumentRequired:
    'Você precisa cadastrar um CPF ou CNPJ antes de assinar um plano pago.',
  cannotRemoveOwner:
    'Você não pode remover o dono do estúdio. Transfira a propriedade antes.',
  cannotRemoveSelf: 'Você não pode remover a si mesmo da equipe.',
  cannotChangeOwnerRole: 'Você não pode alterar o papel do dono do estúdio.',
  ownershipTargetMustBeAdministrator:
    'O novo dono precisa ser administrador do estúdio.',
  cannotChangeSelfRole: 'Você não pode alterar seu próprio papel.',
  invitationEmailMismatch:
    'Este convite foi enviado pra outro e-mail. Entre com a conta convidada.',
  invitationNotFound: 'Convite não encontrado ou link inválido.',
  invitationExpired:
    'Este convite expirou. Solicite um novo ao administrador do estúdio.',
  invitationCanceled: 'Este convite foi cancelado pelo administrador.',
  invitationAlreadyAccepted: 'Este convite já foi aceito.',
  userAlreadyMember: 'Esta pessoa já faz parte da equipe deste estúdio.',
  contractTemplateNotFound: 'Modelo de contrato não encontrado',
  contractTemplateNotTagged:
    'Marque ao menos uma variável no documento antes de salvar o modelo',
  contractTemplateInvalidFile:
    'Arquivo de modelo inválido. Apenas arquivos .docx são permitidos',
  contractAnalysisFailed:
    'Não foi possível analisar o modelo de contrato. Tente novamente',
  contractNotFound: 'Contrato não encontrado',
  contractMissingVariables:
    'Há variáveis obrigatórias do contrato sem preenchimento',
  contractRenderFailed:
    'Não foi possível gerar o documento do contrato. Tente novamente',
  contractInvalidStatusTransition: 'Mudança de status do contrato inválida',
  contractSignedFileTooLarge:
    'O arquivo do contrato assinado excede o tamanho máximo permitido',
  contractorNotFound: 'Contratado não encontrado',
  leadLegalInfoNotFound: 'Dados contratuais do cliente não encontrados',
  clientPortalAccessDenied:
    'Não conseguimos abrir o portal. Confira o link e o CPF',
  clientPortalDocumentRequired:
    'Preencha o CPF do cliente na aba Contratos pra liberar o portal',
  global: 'Erro inesperado. Tente novamente mais tarde',
  boundary: {
    title: 'Algo deu errado',
    description:
      'Encontramos um erro inesperado. Tente recarregar a página ou voltar pra tela inicial.',
    retry: 'Tentar novamente',
    home: 'Voltar pra tela inicial',
  },
};

export default errorsTranslatePTBR;
